import moment from 'moment-timezone'

export const IST_TZ = 'Asia/Kolkata'

export const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

export const DAY_LABELS = {
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
  sun: 'Sunday',
}

const toMinutes = (hhmm) => {
  if (!hhmm || typeof hhmm !== 'string') return null
  const [h, m] = hhmm.split(':').map(Number)
  return h * 60 + m
}

// Reject overnight (start >= end) — MVP scope.
export const isValidRange = (start, end) => {
  const s = toMinutes(start)
  const e = toMinutes(end)
  if (s == null || e == null) return false
  return s < e
}

// True when the driver may be auto-assigned right now.
// Combines: (1) not globally blocked, (2) booking_status == 'available',
// (3) currently inside a configured active-schedule window.
// This is the single decision function the auto-batching engine calls.
export const isDriverBookable = (driver, at) => {
    if (!driver) return false
    if (driver.active === false) return false
    if (driver.booking_status && driver.booking_status !== 'available') return false
    return isDriverActive(driver.active_schedule, at)
}

// True when `at` (or now, in IST) falls within any range for that day of the week.
export const isDriverActive = (schedule, at) => {
  if (!schedule) return false
  const when = at ?? moment().tz(IST_TZ)
  const day = when.format('ddd').toLowerCase()
  const ranges = schedule[day] ?? []
  if (!ranges.length) return false
  const nowMin = when.hour() * 60 + when.minute()
  return ranges.some(r => {
    const s = toMinutes(r.start)
    const e = toMinutes(r.end)
    return s != null && e != null && s <= nowMin && nowMin < e
  })
}
